import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { TextField, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setChalanDetail,
  validateChalanDetail,
} from "../../storeSlices/chalanSlice";
import "./Chalan.css";
import ChalanRasid from "./ChalanRasid";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
const style2 = {
  position: "absolute",
  height: "100%",
  overflow: "scroll",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};
function ChalanForm() {
  let componentRef = useRef();
  const jsonDataString = window.localStorage.getItem("jsonData");
  const ewayBillString = window.localStorage.getItem("ewayBillJson");

  const jsonData = JSON.parse(jsonDataString);
  const ewayBillData = JSON.parse(ewayBillString);
  // console.log("jsonData : ", jsonData);
  // console.log("ewayBillJson : ", ewayBillData);
  const trucksDetails = useSelector((state) => state.dataReducer.trucks);
  console.log("trucksDetails : ", trucksDetails);
  const profileDetails = useSelector((state) => state.dataReducer.profile);
  console.log("profileDetails : ", profileDetails);
  const EwayBillDetails = useSelector((state) => state.dataReducer.ewaybills);
  const partyDetails = useSelector((state) => state.dataReducer.parties);
  const driverDetails = useSelector((state) => state.dataReducer.drivers);
  const [open2, setOpen2] = useState(false);
  useEffect(() => {
    console.log("useEffect hasbeen called");
  }, [open2]);
  // // Testing
  // useEffect(() => {
  //   if (!isEmptyObject(jsonData) || !isEmptyObject(ewayBillData)) {
  //     setdetails((prevState) => ({
  //       ...prevState,
  //       e_way_bill_no: jsonData?.data?.ewayBillNo || "",
  //     }));
  //   }
  // }, []);

  const handleClose2 = () => {
    setOpen2(false);
    console.log("open2  from handleclose: ", open2);
  };
  const printChallan = (props) => {
    setOpen2(true);
    // console.log("props : ", props);
  };
  // const [details, setdetails] = useState({
  //   gst_no: "",
  //   pan_no: "",
  //   client_details: "",
  //   challan_number: "",
  //   cin_no: "",
  //   gr_no: "",
  //   truck_no: "",
  //   freight_mode: "",
  //   freight_type: "",
  //   transporter: "",
  //   vessel_name: "",
  //   driver_name: "",
  //   entery_bill_no: "",
  //   exporter_name: "",
  //   // e_way_bill_no: EwayBillDetails?.num[0].ewaybillno,
  //   e_way_bill_no: "",
  //   billed_to: "",
  //   billed_to_address: "",
  //   billed_state: "",
  //   billed_code: "",
  //   billed_pan: "",
  //   billed_gst: "",
  //   delivery_to_address: "",
  //   delivery_to: "",

  //   delivery_state: "",
  //   delivery_code: "",
  //   delivery_pan: "",
  //   delivery_gst: "",
  //   description_of_goods: "",
  //   hsn_code: "",
  //   qty: "",
  //   uom: "",
  //   rate: "",
  //   amount: "",
  //   total_challan_amount: "",
  //   cessNonAdvol: "",
  //   cessRate: "",
  //   sgstRate: "",
  //   igstRate: "",
  //   updatedby: "",
  //   // weight: "",
  //   // goods: "",
  // });

  const dispatch = useDispatch();

  const chalanReducer = useSelector((state) => state.chalanReducer.chalan);
  console.log("chalanReducer : ", chalanReducer);
  const [details, setdetails] = useState({
    gst_no: chalanReducer.gst_no || "",
    pan_no: chalanReducer.pan_no || "",
    gr_date: chalanReducer.gr_date || "",
    date: chalanReducer.date || "",
    invoice_no: chalanReducer.invoice_no || "",
    invoice_date: chalanReducer.invoice_date || "",
    client_details: chalanReducer.client_details || "",
    challan_number: chalanReducer.challan_number || "",
    cin_no: chalanReducer.cin_no || "",
    gr_no: chalanReducer.gr_no || "",
    truck_no: chalanReducer.truck_no || "",
    freight_mode: chalanReducer.freight_mode || "",
    freight_type: chalanReducer.freight_type || "",
    transporter: chalanReducer.transporter || "",
    vessel_name: chalanReducer.vessel_name || "",
    driver_name: chalanReducer.driver_name || "",
    entery_bill_no: chalanReducer.entery_bill_no || "",
    exporter_name: chalanReducer.exporter_name || "",
    e_way_bill_no: chalanReducer.e_way_bill_no || "",
    billed_to: chalanReducer.billed_to || "",
    billed_to_address: chalanReducer.billed_to_address || "",
    billed_state: chalanReducer.billed_state || "",
    billed_code: chalanReducer.billed_code || "",
    billed_pan: chalanReducer.billed_pan || "",
    billed_gst: chalanReducer.billed_gst || "",
    delivery_to_address: chalanReducer.delivery_to_address || "",
    delivery_to: chalanReducer.delivery_to || "",
    delivery_state: chalanReducer.delivery_state || "",
    delivery_code: chalanReducer.delivery_code || "",
    delivery_pan: chalanReducer.delivery_pan || "",
    delivery_gst: chalanReducer.delivery_gst || "",
    description_of_goods: chalanReducer.description_of_goods || "",
    hsn_code: chalanReducer.hsn_code || "",
    qty: chalanReducer.qty || "",
    uom: chalanReducer.uom || "",
    rate: chalanReducer.rate || "",
    amount: chalanReducer.amount || "",
    total_challan_amount: chalanReducer.total_challan_amount || "",
    cessNonAdvol: chalanReducer.cessNonAdvol || 0,
    cessRate: chalanReducer.cessRate || 0,
    sgstRate: chalanReducer.sgstRate || 0,
    igstRate: chalanReducer.igstRate || 0,
    updatedby: chalanReducer.updatedby || "",
  });

  //calculation

  useEffect(() => {
    if (details.rate !== "" && details.qty !== "") {
      const amount = details?.rate * details?.qty;
      setdetails((prevdetails) => ({
        ...prevdetails,
        amount: amount,
      }));
    }
  }, [details.rate, details.qty]);

  useEffect(() => {
    if (
      details.amount !== "" &&
      details.sgstRate !== "" &&
      details.igstRate !== "" &&
      details.cessRate !== "" &&
      details.cessNonAdvol !== ""
    ) {
      const total =
        details?.amount +
        (details?.amount * details?.sgstRate * 2) / 100 +
        (details?.amount * details?.igstRate) / 100 +
        (details?.amount * details?.cessRate) / 100 +
        Number(details?.cessNonAdvol * details?.qty);
      setdetails((prevdetails) => ({
        ...prevdetails,
        total_challan_amount: total,
      }));
    }
  }, [
    details.amount,
    details.sgstRate,
    details.igstRate,
    details.cessRate,
    details.cessNonAdvol,
    details.qty,
  ]);

  // calculation ends added by sachin

  // to clear form button function

  const handleClearData = () => {
    setdetails({
      gst_no: "",
      pan_no: "",
      gr_date: "",
      date: "",
      invoice_no: "",
      invoice_date: "",
      client_details: "",
      challan_number: "",
      cin_no: "",
      gr_no: "",
      truck_no: "",
      freight_mode: "",
      freight_type: "",
      transporter: "",
      vessel_name: "",
      driver_name: "",
      entery_bill_no: "",
      exporter_name: "",
      e_way_bill_no: "",
      billed_to: "",
      billed_to_address: "",
      billed_state: "",
      billed_code: "",
      billed_pan: "",
      billed_gst: "",
      delivery_to_address: "",
      delivery_to: "",
      delivery_state: "",
      delivery_code: "",
      delivery_pan: "",
      delivery_gst: "",
      description_of_goods: "",
      hsn_code: "",
      qty: "",
      uom: "",
      rate: "",
      amount: "",
      total_challan_amount: "",
      cessNonAdvol: 0,
      cessRate: 0,
      sgstRate: 0,
      igstRate: 0,
      updatedby: "",
    });
  };

  // retrive data from E-way form

  const handleRetrieveData = () => {
    if (!isEmptyObject(jsonData) || !isEmptyObject(ewayBillData)) {
      const getActFromStateCode = () => {
        switch (Number(ewayBillData?.actFromStateCode)) {
          case 1:
            return "JAMMU AND KASHMIR";
          case 2:
            return "HIMACHAL PRADESH";
          case 3:
            return "PUNJAB";
          case 4:
            return "CHANDIGARH";
          case 5:
            return "UTTARAKHAND";
          case 6:
            return "HARYANA";
          case 7:
            return "DELHI";
          case 8:
            return "RAJASTHAN";
          case 9:
            return "UTTAR PRADESH";
          case 10:
            return "BIHAR";
          case 11:
            return "SIKKIM";
          case 12:
            return "ARUNACHAL PRADESH";
          case 13:
            return "NAGALAND";
          case 14:
            return "MANIPUR";
          case 15:
            return "MIZORAM";
          case 16:
            return "TRIPURA";
          case 17:
            return "MEGHALAYA";
          case 18:
            return "ASSAM";
          case 19:
            return "WEST BENGAL";
          case 20:
            return "JHARKHAND";
          case 21:
            return "ORISSA";
          case 22:
            return "CHHATTISGARH";
          case 23:
            return "MADHYA PRADESH";
          case 24:
            return "GUJARAT";
          case 26:
            return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
          case 27:
            return "MAHARASHTRA";
          case 29:
            return "KARNATAKA";
          case 30:
            return "GOA";
          case 31:
            return "LAKSHADWEEP";
          case 32:
            return "KERALA";
          case 33:
            return "TAMIL NADU";
          case 34:
            return "PUDUCHERRY";
          case 35:
            return "ANDAMAN AND NICOBAR";
          case 36:
            return "TELANGANA";
          case 37:
            return "ANDHRA PRADESH";
          case 38:
            return "LADAKH";
          case 97:
            return "OTHER TERRITORY";
          case 99:
            return "OTHER COUNTRY";
          default:
            return ewayBillData?.actFromStateCode;
        }
      };

      const getActToStateCode = () => {
        switch (Number(ewayBillData?.actToStateCode)) {
          case 1:
            return "JAMMU AND KASHMIR";
          case 2:
            return "HIMACHAL PRADESH";
          case 3:
            return "PUNJAB";
          case 4:
            return "CHANDIGARH";
          case 5:
            return "UTTARAKHAND";
          case 6:
            return "HARYANA";
          case 7:
            return "DELHI";
          case 8:
            return "RAJASTHAN";
          case 9:
            return "UTTAR PRADESH";
          case 10:
            return "BIHAR";
          case 11:
            return "SIKKIM";
          case 12:
            return "ARUNACHAL PRADESH";
          case 13:
            return "NAGALAND";
          case 14:
            return "MANIPUR";
          case 15:
            return "MIZORAM";
          case 16:
            return "TRIPURA";
          case 17:
            return "MEGHALAYA";
          case 18:
            return "ASSAM";
          case 19:
            return "WEST BENGAL";
          case 20:
            return "JHARKHAND";
          case 21:
            return "ORISSA";
          case 22:
            return "CHHATTISGARH";
          case 23:
            return "MADHYA PRADESH";
          case 24:
            return "GUJARAT";
          case 26:
            return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
          case 27:
            return "MAHARASHTRA";
          case 29:
            return "KARNATAKA";
          case 30:
            return "GOA";
          case 31:
            return "LAKSHADWEEP";
          case 32:
            return "KERALA";
          case 33:
            return "TAMIL NADU";
          case 34:
            return "PUDUCHERRY";
          case 35:
            return "ANDAMAN AND NICOBAR";
          case 36:
            return "TELANGANA";
          case 37:
            return "ANDHRA PRADESH";
          case 38:
            return "LADAKH";
          case 97:
            return "OTHER TERRITORY";
          case 99:
            return "OTHER COUNTRY";
          default:
            return ewayBillData?.actToStateCode;
        }
      };
      const retrievedFormData = {
        gst_no: ewayBillData?.fromGstin || "",
        pan_no: "",
        gr_date: ewayBillData?.transDocDate || "",
        date: "",
        invoice_no: "",
        invoice_date: "",
        client_details: "",
        challan_number: ewayBillData?.docNo || "",
        cin_no: "",
        gr_no: ewayBillData?.transDocNo || "",
        truck_no: ewayBillData?.vehicleNo || "",
        freight_mode: "",
        freight_type: "",
        transporter: ewayBillData?.transporterName || "",
        vessel_name: "",
        driver_name: "",
        entery_bill_no: "",
        exporter_name: "",
        e_way_bill_no: jsonData?.data?.ewayBillNo || "",
        billed_to: ewayBillData?.fromTrdName || "",
        billed_to_address:
          (ewayBillData?.fromAddr1 || " ") + (ewayBillData?.fromPlace || " "),
        billed_state: getActFromStateCode() || "",
        billed_code: ewayBillData?.fromPincode || "",
        billed_pan: "",
        billed_gst: ewayBillData?.fromGstin || "",
        delivery_to_address:
          (ewayBillData?.toAddr1 || " ") + (ewayBillData?.toPlace || " "),
        delivery_to: ewayBillData?.toTrdName || "",
        delivery_state: getActToStateCode() || "",
        delivery_code: ewayBillData?.actToStateCode || "",
        delivery_pan: "",
        delivery_gst: ewayBillData?.toGstin || "",
        description_of_goods: "",
        hsn_code: ewayBillData?.hsnCode || "",
        qty: ewayBillData?.quantity || "",
        uom: ewayBillData?.qtyUnit || "",
        rate: ewayBillData?.rate || "",
        amount: ewayBillData?.taxableAmount || "",
        total_challan_amount: "",
        cessNonAdvol: ewayBillData?.cessNonAdvol || "",
        cessRate: ewayBillData?.cessRate || "",
        sgstRate: ewayBillData?.sgstRate || "",
        igstRate: ewayBillData?.igstRate || "",
        updatedby: "",
      };
      setdetails(retrievedFormData);
    }
  };

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("details in chalan form : ", details);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/challan/`,
      //`http://localhost:5000/challan/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log("details in chalan form : ", details);
    console.log("json in chalan form : ", json);
    // first validate chalan details
    dispatch(validateChalanDetail(details));

    // set chalan details
    dispatch(setChalanDetail(details));

    document.getElementById("bill-form").classList.toggle("c-form");
    document.getElementById("bill-template").classList.toggle("bill"); //
  };
  return (
    <div className="chalan-form-container">
      <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
        {/* <label>E-way Bill No: {EwayBillDetails.num[0].ewaybillno}</label> */}
        <Button
          type="button"
          style={{
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleClearData}
        >
          Clear Form
        </Button>
        {"  "}
        <Button
          type="button"
          style={{
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleRetrieveData}
        >
          Retrieve Data
        </Button>
        <label style={{ marginTop: "10px" }}>
          E-way Bill Number
          <input
            type="text"
            name="e_way_bill_no"
            value={details.e_way_bill_no}
            onChange={handleChange}
          />
        </label>
        <label>
          {/* E-way Bill No: */}
          {
            // JSON.stringify(EwayBillDetails) === {} ? (
            //   <input
            //     type="text"
            //     name="e_way_bill_no"
            //     value={details.e_way_bill_no}
            //     onChange={handleChange}
            //   />
            // ) :
            //(
            // <>
            //   <input type="text" list="e_way_bill_no" />
            //   <datalist
            //     name="e_way_bill_no"
            //     id="e_way_bill_no"
            //     onChange={handleChange}
            //   >
            //     {Object.entries(EwayBillDetails.num).map((item, index) => {
            //       //here we convert object to array and then map it to get the values, how to get last value
            //       if (
            //         index + 1 ===
            //         Object.entries(EwayBillDetails.num).length
            //       ) {
            //         return (
            //           <option
            //             name="e_way_bill_no"
            //             key={index}
            //             value={item[1].ewaybillno}
            //           >
            //             {/* {setewaybillnu(item[1].ewaybillno)} */}
            //             {item[1].ewaybillno}
            //           </option>
            //         );
            //       }
            //     })}
            //   </datalist>
            // </>
            // )
          }
        </label>
        <br />
        {/* <label>
          Client Details
          {JSON.stringify(partyDetails) === {} ? (
            <input
              type="text"
              name="client_details"
              value={details.client_details}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="client_name" />
              <datalist
                name="client_details"
                id="client_name"
                onChange={handleChange}
              >
                {Object.entries(partyDetails.client).map((item, index) => {
                  return (
                    <option
                      name="client_details"
                      key={index}
                      value={item[1].name}
                    >
                      {item[1].name}
                    </option>
                  );
                })}
              </datalist>
            </>
          )}
        </label>
        <br /> */}
        <label>
          Bill of Entry No:
          <input
            type="text"
            name="entery_bill_no"
            value={details.entery_bill_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          date
          <input
            type="date"
            name="date"
            value={details.date}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GST No:
          <input
            type="text"
            name="gst_no"
            value={details.gst_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Pan No:
          <input
            type="text"
            name="pan_no"
            value={details.pan_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Cin No:
          <input
            type="text"
            name="cin_no"
            value={details.cin_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Gr No:
          <input
            type="text"
            name="gr_no"
            value={details.gr_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GR date:
          <input
            type="text"
            name="gr_date"
            value={details.gr_date}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Invoice Number
          <input
            type="text"
            name="invoice_no"
            value={details.invoice_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Invoice Date
          <input
            type="text"
            name="invoice_date"
            value={details.invoice_date}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Challan No
          <input
            type="text"
            name="challan_number"
            value={details.challan_number}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Truck No:
          <input
            type="text"
            name="truck_no"
            value={details.truck_no}
            onChange={handleChange}
          />
          {/* {JSON.stringify(trucksDetails) === {} ? (
            <input
              type="text"
              name="truck_no"
              value={details.truck_no}
              onChange={handleChange}
            />
          ) : (
            <>
              <input type="text" list="gaadi_no" />
              <datalist name="truck_no" id="gaadi_no" onChange={handleChange}>
                {Object.entries(trucksDetails.car).map((item, index) => {
                  return (
                    <option
                      name="truck_no"
                      key={index}
                      value={item[1].gaadi_no}
                    >
                      {item[1].gaadi_no}
                    </option>
                  );
                })}
              </datalist>
            </>
          )} */}
        </label>
        <br />
        <label>
          Freight Mode:
          <input
            type="text"
            name="freight_mode"
            value={details.freight_mode}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Freight Type:
          <input
            type="text"
            name="freight_type"
            value={details.freight_type}
            onChange={handleChange}
          />
        </label>
        <br />
        {/* <label>
          Goods:
          <input
            type="text"
            name="goods"
            value={details.goods}
            onChange={handleChange}
          />
        </label>
        <br /> */}
        <label>
          Transporter Name:
          <input
            type="text"
            name="transporter"
            value={details.transporter}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Vessel Name:
          <input
            type="text"
            name="vessel_name"
            value={details.vessel_name}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Exporter Name:
          <input
            type="text"
            name="exporter_name"
            value={details.exporter_name}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          {profileDetails &&
          profileDetails.pro &&
          profileDetails.pro["name"] === "SHREE MAHAVEER TRANSPORT COMPANY" ? (
            <h2>Billed To:</h2>
          ) : (
            <h2>Billed From:</h2>
          )}
          {/* <h2> Billed From:</h2> */}
          <input
            type="text"
            name="billed_to"
            value={details.billed_to}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Address
          <input
            type="text"
            name="billed_to_address"
            value={details.billed_to_address}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          State:
          <input
            type="text"
            name="billed_state"
            value={details.billed_state}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Code:
          <input
            type="number"
            name="billed_code"
            value={details.billed_code}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GST Number:
          <input
            type="text"
            name="billed_gst"
            value={details.billed_gst}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          PAN Number:
          <input
            type="text"
            name="billed_pan"
            value={details.billed_pan}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Weight:
          <input
            type="number"
            name="weight"
            value={details.weight}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Driver Name:
          {driverDetails ? (
            <input
              type="text"
              name="driver_name"
              value={details.driver_name}
              onChange={handleChange}
            />
          ) : (
            <select name="driver_name" id="Driver_name" onChange={handleChange}>
              {Object.entries(driverDetails.drive).map((item, index) => {
                return (
                  <option
                    name="driver_name"
                    key={index}
                    value={item[1].driver_name}
                  >
                    {item[1].name}
                  </option>
                );
              })}
            </select>
          )}
          {/* <input
            type="text"
            name="driver_name"
            value={details.driver_name}
            onChange={handleChange}
          /> */}
          {/* <select name="driver_name" id="Driver_name" onChange={handleChange}>
            {Object.entries(driverDetails.drive).map((item, index) => {
              return (
                <option
                  name="driver_name"
                  key={index}
                  value={item[1].driver_name}
                >
                  {item[1].name}
                </option>
              );
            })}
          </select> */}
        </label>
        <br />
        <label>
          {profileDetails &&
          profileDetails.pro &&
          profileDetails.pro["name"] === "SHREE MAHAVEER TRANSPORT COMPANY" ? (
            <h2>Delivery To:</h2>
          ) : (
            <h2>Billed and Delivery To:</h2>
          )}
          {/* <h2> Delivery To:</h2> */}
          <input
            type="text"
            name="delivery_to"
            value={details.delivery_to}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Address
          <input
            type="text"
            name="delivery_to_address"
            value={details.delivery_to_address}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          State:
          <input
            type="text"
            name="delivery_state"
            value={details.delivery_state}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Code:
          <input
            type="number"
            name="delivery_code"
            value={details.delivery_code}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GST Number:
          <input
            type="text"
            name="delivery_gst"
            value={details.delivery_gst}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          PAN Number:
          <input
            type="text"
            name="delivery_pan"
            value={details.delivery_pan}
            onChange={handleChange}
          />
        </label>
        <br />
        <br />
        <label>
          Description Of Goods:
          <input
            type="text"
            name="description_of_goods"
            value={details.description_of_goods}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          HSN CODE:
          <input
            type="text"
            name="hsn_code"
            value={details.hsn_code}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          QTY:
          <input
            type="number"
            name="qty"
            value={details.qty}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          UOM:
          <input
            type="text"
            name="uom"
            value={details.uom}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          rate:
          <input
            type="number"
            name="rate"
            value={details.rate}
            onChange={handleChange}
          />
        </label>
        <br />
        <div>
          <table>
            <thead>
              <tr>
                <th>CGST+ SGST Rate(%) </th>
                <th>IGST Rate(%)</th>
                <th>CESS Advol Rate(%)</th>
                <th>CESS non.Advol. Rate</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <select
                    className="selectt"
                    name="sgstRate"
                    id="document-type"
                    onChange={handleChange}
                    value={details.sgstRate}
                  >
                    <option name="sgstRate" value="-1">
                      -Select-
                    </option>
                    <option name="sgstRate" value="0.500">
                      0.500 + 0.500
                    </option>
                    <option name="sgstRate" value="0.750">
                      0.750 + 0.750
                    </option>
                    <option name="sgstRate" value="3.750">
                      3.750 + 3.750
                    </option>
                    <option name="sgstRate" value="0.000">
                      0 + 0{" "}
                    </option>
                    <option name="sgstRate" value="2.500">
                      2.500 + 2.500
                    </option>
                    <option name="sgstRate" value="6.000">
                      6 + 6{" "}
                    </option>
                    <option name="sgstRate" value="9.000">
                      9 + 9{" "}
                    </option>
                    <option name="sgstRate" value="14.000">
                      14 + 14{" "}
                    </option>
                    <option name="sgstRate" value="1.500">
                      1.500 + 1.500
                    </option>
                    <option name="sgstRate" value="0.050">
                      0.050 + 0.050
                    </option>
                    <option name="sgstRate" value="0.125">
                      0.125 + 0.125
                    </option>
                    <option name="sgstRate" value="3.000">
                      3 + 3{" "}
                    </option>
                    <option name="sgstRate" value="-2">
                      -Not Appl-
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    className="selectt"
                    name="igstRate"
                    id="document-type"
                    onChange={handleChange}
                    value={details.igstRate}
                  >
                    <option name="igstRate" value="-1">
                      -Select-
                    </option>
                    <option name="igstRate" value="1.000">
                      1
                    </option>
                    <option name="igstRate" value="1.500">
                      1.500
                    </option>
                    <option name="igstRate" value="7.500">
                      7.500
                    </option>
                    <option name="igstRate" value="0.000">
                      0
                    </option>
                    <option name="igstRate" value="5.000">
                      5
                    </option>
                    <option name="igstRate" value="12.000">
                      12
                    </option>
                    <option name="igstRate" value="18.000">
                      18
                    </option>
                    <option name="igstRate" value="28.000">
                      28
                    </option>
                    <option name="igstRate" value="3.000">
                      3
                    </option>
                    <option name="igstRate" value="0.100">
                      0.100
                    </option>
                    <option name="igstRate" value="0.250">
                      0.250
                    </option>
                    <option name="igstRate" value="6.000">
                      6
                    </option>
                    <option name="igstRate" value="-2">
                      -Not Appl-
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    className="selectt"
                    name="cessRate"
                    id="document-type"
                    onChange={handleChange}
                    value={details.cessRate}
                  >
                    <option value="-1">-Select-</option>
                    <option selected="selected" value="0.000" name="cessRate">
                      0
                    </option>
                    <option name="cessRate" value="1.000">
                      1
                    </option>
                    <option name="cessRate" value="3.000">
                      3
                    </option>
                    <option name="cessRate" value="5.000">
                      5
                    </option>
                    <option name="cessRate" value="11.000">
                      11
                    </option>
                    <option name="cessRate" value="12.000">
                      12
                    </option>
                    <option name="cessRate" value="12.500">
                      12.500
                    </option>
                    <option name="cessRate" value="15.000">
                      15
                    </option>
                    <option name="cessRate" value="17.000">
                      17
                    </option>
                    <option name="cessRate" value="20.000">
                      20
                    </option>
                    <option name="cessRate" value="21.000">
                      21
                    </option>
                    <option name="cessRate" value="22.000">
                      22
                    </option>
                    <option name="cessRate" value="36.000">
                      36
                    </option>
                    <option name="cessRate" value="49.000">
                      49
                    </option>
                    <option name="cessRate" value="60.000">
                      60
                    </option>
                    <option name="cessRate" value="61.000">
                      61
                    </option>
                    <option name="cessRate" value="65.000">
                      65
                    </option>
                    <option name="cessRate" value="71.000">
                      71
                    </option>
                    <option name="cessRate" value="72.000">
                      72
                    </option>
                    <option name="cessRate" value="89.000">
                      89
                    </option>
                    <option name="cessRate" value="96.000">
                      96
                    </option>
                    <option name="cessRate" value="142.000">
                      142
                    </option>
                    <option name="cessRate" value="160.000">
                      160
                    </option>
                    <option name="cessRate" value="204.000">
                      204
                    </option>
                    <option name="cessRate" value="290.000">
                      290
                    </option>
                    <option name="cessRate" value="-2">
                      -Not Appl-
                    </option>
                  </select>
                </td>
                <td>
                  {/* <input
                    type="text"
                    name="Item_Details_CESS_NonAdvol_Rate"
                    onChange={handleChange}
                    value={ewayBill.Item_Details_CESS_NonAdvol_Rate}
                  /> */}
                  <select
                    className="selectt"
                    name="cessNonAdvol"
                    id="document-type"
                    onChange={handleChange}
                    value={details.cessNonAdvol}
                  >
                    <option name="cessNonAdvol" value="-1">
                      -Select-
                    </option>
                    <option
                      name="cessNonAdvol"
                      selected="selected"
                      value="0.000"
                    >
                      0
                    </option>
                    <option name="cessNonAdvol" value="400.000">
                      400
                    </option>
                    <option name="cessNonAdvol" value="2076.000">
                      2076
                    </option>
                    <option name="cessNonAdvol" value="2747.000">
                      2747
                    </option>
                    <option name="cessNonAdvol" value="3668.000">
                      3668
                    </option>
                    <option name="cessNonAdvol" value="4006.000">
                      4006
                    </option>
                    <option name="cessNonAdvol" value="4170.000">
                      4170
                    </option>
                    <option name="cessNonAdvol" value="-2">
                      -Not Appl-
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <label>
          {/* Amount: {details.rate * details.qty} */}
          Amount:{" "}
          {
            details.rate * details.qty
            // (details.amount =
            //   details?.rate * details?.qty +
            //   (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
            //   (details?.rate * details?.qty * details?.igstRate) / 100 +
            //   (details?.rate * details?.qty * details?.cessRate) / 100 +
            //   Number(details?.cessNonAdvol))
          }
          <input
            type="text"
            name="amount"
            // value={details.rate * details.qty}
            value={details.amount}
            placeholder="write manually"
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Total Chalan Amount:{" "}
          {details?.rate * details?.qty +
            (details?.rate * details?.qty * details?.sgstRate * 2) / 100 +
            (details?.rate * details?.qty * details?.igstRate) / 100 +
            (details?.rate * details?.qty * details?.cessRate) / 100 +
            Number(details?.cessNonAdvol)}
          <input
            type="text"
            name="total_challan_amount"
            // value={(details.total_challan_amount = details.amount)}
            value={details.total_challan_amount}
            onChange={handleChange}
            placeholder="write manually"
          />
        </label>
        <br />
        <label>
          Updated By:
          <input
            type="text"
            name="updatedby"
            value={details.updatedby}
            onChange={handleChange}
          />
        </label>
        <br />
        <input className="generate" type="submit" value="Generate Chalan" />
        <button
          type="button"
          onClick={(event) => {
            event.preventDefault();
            printChallan();
          }}
        >
          {" "}
          Print EwayBill Form{" "}
        </button>
      </form>

      {(!isEmptyObject(jsonData) || !isEmptyObject(ewayBillData)) && (
        <Modal
          open={open2}
          onClose={handleClose2}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style2}>
            <>
              <div className="" ref={(el) => (componentRef = el)}>
                <div className="second" style={{ alignItems: "center" }}>
                  <h3>E-WAY BILL Details</h3>
                </div>
                <div
                  className="first  "
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                    // border: "1px solid black",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    <div>
                      <p>eWay Bill No</p>
                      <p>{jsonData?.data?.ewayBillNo || "Not available"}</p>
                    </div>
                    <div>
                      <p>Generated Date</p>
                      <p>{jsonData?.data?.ewayBillDate || "Not available"}</p>
                    </div>
                    <div>
                      <p>Generated By:</p>
                      <p>{jsonData?.header?.gstin}</p>
                    </div>
                    <div>
                      <p>Valid Upto:</p>
                      <p>{jsonData?.data?.validUpto || "Not available"}</p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    {/* <div>
                      <p>mode</p>
                      <p>road</p>
                    </div> */}
                    <div>
                      <p>mode</p>
                      <p>
                        {(() => {
                          switch (Number(ewayBillData?.transMode)) {
                            case 1:
                              return "road";
                            case 2:
                              return "rail";
                            case 3:
                              return "air";
                            case 4:
                              return "ship";
                            default:
                              return "---";
                          }
                        })()}
                      </p>
                    </div>

                    <div>
                      <p>Approx Distance</p>
                      <p>{ewayBillData?.transDistance}km</p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    <div>
                      <p>Type</p>
                      {(() => {
                        let inwardType, skdCkdLotsType;
                        if (ewayBillData?.supplyType === "I") {
                          inwardType = "inward";
                        } else if (ewayBillData?.supplyType === "O") {
                          inwardType = "outward";
                        }
                        switch (Number(ewayBillData?.subSupplyType)) {
                          case 1:
                            skdCkdLotsType = "Supply";
                            break;
                          case 2:
                            skdCkdLotsType = "Import";
                            break;
                          case 3:
                            skdCkdLotsType = "Export";
                            break;
                          case 4:
                            skdCkdLotsType = "Job Work";
                            break;
                          case 5:
                            skdCkdLotsType = "For Own use";
                            break;
                          case 6:
                            skdCkdLotsType = "Job work Returns";
                            break;
                          case 7:
                            skdCkdLotsType = "Sales Return";
                            break;
                          case 8:
                            skdCkdLotsType = "Others";
                            break;
                          case 9:
                            skdCkdLotsType = "SKD/CKD/Lots";
                            break;
                          case 10:
                            skdCkdLotsType = "Line Sales";
                            break;
                          case 11:
                            skdCkdLotsType = "Recipient Not Known";
                            break;
                          case 12:
                            skdCkdLotsType = "Exhibition or Fairs";
                            break;
                          default:
                            skdCkdLotsType = "Unknown";
                            break;
                        }

                        return (
                          <p>
                            {inwardType} - {skdCkdLotsType}
                          </p>
                        );
                      })()}
                    </div>
                    <div>
                      <p>Document Details</p>
                      <p>
                        {ewayBillData?.docType} - {ewayBillData?.docNo} -{" "}
                        {ewayBillData?.docDate}
                      </p>
                    </div>
                    <div>
                      <p>Transaction Type</p>
                      <p>
                        {(() => {
                          switch (Number(ewayBillData?.transactionType)) {
                            case 1:
                              return "Regular";
                            case 2:
                              return "Bill To-Ship To";
                            case 3:
                              return "Bill From-Dispatch From";
                            case 4:
                              return "Combination of 2 and 3";
                            default:
                              return ewayBillData?.transactionType;
                          }
                        })()}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="second" style={{ alignItems: "center" }}>
                  <h3>2.Address Details</h3>
                </div>
                <div
                  className="second1 "
                  style={{
                    height: "100%",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      width: "50%",
                      paddingLeft: "10px",

                      padding: "10px",
                    }}
                  >
                    <p style={{ padding: "5px" }}>
                      <b>From</b>{" "}
                    </p>
                    <div>
                      <div>
                        <p>gstin : {ewayBillData?.fromGstin}</p>
                        <p>{ewayBillData?.fromTrdName}</p>
                        <p>: Dispatch From ::</p>
                        <p>
                          {ewayBillData?.fromAddr1} {ewayBillData?.fromPlace},
                          {(() => {
                            switch (Number(ewayBillData?.actFromStateCode)) {
                              case 1:
                                return "JAMMU AND KASHMIR";
                              case 2:
                                return "HIMACHAL PRADESH";
                              case 3:
                                return "PUNJAB";
                              case 4:
                                return "CHANDIGARH";
                              case 5:
                                return "UTTARAKHAND";
                              case 6:
                                return "HARYANA";
                              case 7:
                                return "DELHI";
                              case 8:
                                return "RAJASTHAN";
                              case 9:
                                return "UTTAR PRADESH";
                              case 10:
                                return "BIHAR";
                              case 11:
                                return "SIKKIM";
                              case 12:
                                return "ARUNACHAL PRADESH";
                              case 13:
                                return "NAGALAND";
                              case 14:
                                return "MANIPUR";
                              case 15:
                                return "MIZORAM";
                              case 16:
                                return "TRIPURA";
                              case 17:
                                return "MEGHALAYA";
                              case 18:
                                return "ASSAM";
                              case 19:
                                return "WEST BENGAL";
                              case 20:
                                return "JHARKHAND";
                              case 21:
                                return "ORISSA";
                              case 22:
                                return "CHHATTISGARH";
                              case 23:
                                return "MADHYA PRADESH";
                              case 24:
                                return "GUJARAT";
                              case 26:
                                return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
                              case 27:
                                return "MAHARASHTRA";
                              case 29:
                                return "KARNATAKA";
                              case 30:
                                return "GOA";
                              case 31:
                                return "LAKSHADWEEP";
                              case 32:
                                return "KERALA";
                              case 33:
                                return "TAMIL NADU";
                              case 34:
                                return "PUDUCHERRY";
                              case 35:
                                return "ANDAMAN AND NICOBAR";
                              case 36:
                                return "TELANGANA";
                              case 37:
                                return "ANDHRA PRADESH";
                              case 38:
                                return "LADAKH";
                              case 97:
                                return "OTHER TERRITORY";
                              case 99:
                                return "OTHER COUNTRY";
                              default:
                                return ewayBillData?.actFromStateCode;
                            }
                          })()}
                          -{ewayBillData?.fromPincode}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      width: "50%",
                      paddingLeft: "10px",
                      padding: "10px",
                    }}
                  >
                    <p style={{ padding: "5px" }}>
                      {" "}
                      <b>To</b>
                    </p>
                    <div>
                      <p>gstin : {ewayBillData?.toGstin}</p>
                      <p>{ewayBillData?.toTrdName}</p>
                      <p>: Ship to ::</p>
                      <p>
                        {ewayBillData?.toAddr1} {ewayBillData?.toPlace},
                        {(() => {
                          switch (Number(ewayBillData?.actToStateCode)) {
                            case 1:
                              return "JAMMU AND KASHMIR";
                            case 2:
                              return "HIMACHAL PRADESH";
                            case 3:
                              return "PUNJAB";
                            case 4:
                              return "CHANDIGARH";
                            case 5:
                              return "UTTARAKHAND";
                            case 6:
                              return "HARYANA";
                            case 7:
                              return "DELHI";
                            case 8:
                              return "RAJASTHAN";
                            case 9:
                              return "UTTAR PRADESH";
                            case 10:
                              return "BIHAR";
                            case 11:
                              return "SIKKIM";
                            case 12:
                              return "ARUNACHAL PRADESH";
                            case 13:
                              return "NAGALAND";
                            case 14:
                              return "MANIPUR";
                            case 15:
                              return "MIZORAM";
                            case 16:
                              return "TRIPURA";
                            case 17:
                              return "MEGHALAYA";
                            case 18:
                              return "ASSAM";
                            case 19:
                              return "WEST BENGAL";
                            case 20:
                              return "JHARKHAND";
                            case 21:
                              return "ORISSA";
                            case 22:
                              return "CHHATTISGARH";
                            case 23:
                              return "MADHYA PRADESH";
                            case 24:
                              return "GUJARAT";
                            case 26:
                              return "DADAR AND NAGAR HAVELI & DAMAN AND DIU";
                            case 27:
                              return "MAHARASHTRA";
                            case 29:
                              return "KARNATAKA";
                            case 30:
                              return "GOA";
                            case 31:
                              return "LAKSHADWEEP";
                            case 32:
                              return "KERALA";
                            case 33:
                              return "TAMIL NADU";
                            case 34:
                              return "PUDUCHERRY";
                            case 35:
                              return "ANDAMAN AND NICOBAR";
                            case 36:
                              return "TELANGANA";
                            case 37:
                              return "ANDHRA PRADESH";
                            case 38:
                              return "LADAKH";
                            case 97:
                              return "OTHER TERRITORY";
                            case 99:
                              return "OTHER COUNTRY";
                            default:
                              return ewayBillData?.actToStateCode;
                          }
                        })()}
                        -{ewayBillData?.toPincode}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="second" style={{ alignItems: "center" }}>
                  <h3>3. Goods Details</h3>
                </div>
                <div className="second" style={{ height: "100%" }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Product Name & Desc. </th>
                        <th>HSN Code </th>
                        <th>Quantity</th>
                        <th>Taxable Amount Rs</th>
                        <th>Tax Rate (C+S+I+Cess+Cess Non.Advol)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{ewayBillData?.productDesc}</td>
                        <td>{ewayBillData?.hsnCode}</td>
                        <td>{ewayBillData?.quantity}</td>
                        <td>{ewayBillData?.taxableAmount}</td>
                        <td>
                          {ewayBillData?.sgstRate +
                            "+" +
                            ewayBillData?.sgstRate +
                            "+" +
                            ewayBillData?.igstRate +
                            "+" +
                            ewayBillData?.cessRate +
                            "+" +
                            ewayBillData?.cessNonAdvol}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="second" style={{ height: "100%" }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Tot. Tax'ble Amt </th>
                        <th>CGST Amt</th>
                        <th> SGST Amt</th>
                        <th>IGST Amt</th>
                        <th>CESS Amt</th>
                        <th>CESS Non.Advol Amt </th>
                        <th>Other Amt </th>
                        <th>Total Inv.Amt</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td> {ewayBillData?.taxableAmount}</td>
                        <td>{ewayBillData?.cgstValue}</td>
                        <td>{ewayBillData?.sgstValue}</td>
                        <td>{ewayBillData?.igstValue}</td>
                        <td>{ewayBillData?.cessValue}</td>
                        <td>{ewayBillData?.TolNonAdolVal}</td>
                        <td>{ewayBillData?.OthValue}</td>
                        <td>{ewayBillData?.totInvValue}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="second" style={{ alignItems: "center" }}>
                  <h3>4. Transportation Details</h3>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    padding: "10px",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <p>Transporter ID & Name : </p>
                    <p>
                      {" "}
                      {ewayBillData?.transporterId +
                        " & " +
                        ewayBillData?.transporterName}
                    </p>
                  </div>
                  <div style={{ display: "flex" }}>
                    <p>Transporter Doc. No & Date</p>
                    <p>
                      {ewayBillData?.transDocNo +
                        "&" +
                        ewayBillData?.transDocDate}
                    </p>
                  </div>
                </div>
                <div className="second" style={{ alignItems: "center" }}>
                  <h3>5. Vehicle Details</h3>
                </div>
                <div className="second" style={{ height: "100%" }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Mode </th>
                        <th>Vehicle / Trans Doc No & Dt.</th>
                        <th>From</th>
                        <th>Entered Date </th>
                        <th>Entered By</th>
                        <th>CEWB No. (If any)</th>
                        <th>Multi Veh.Info (If any)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* <tr>
                        <td> Road</td>
                        <td>NE+NE+18.000+0.000+0.00</td>
                        <td>42.23 MTS</td>
                        <td>713421.80 wedwq e </td>
                        <td>NE+NE+18.000+0.</td>
                        <td>-</td>
                        <td>-</td>
                      </tr> */}
                      <tr>
                        <td> Road</td>
                        <td>
                          {ewayBillData?.vehicleNo} & {ewayBillData?.transDocNo}{" "}
                          {ewayBillData?.transDocDate}
                        </td>
                        <td>{ewayBillData?.fromPlace}</td>
                        <td>{jsonData?.data?.ewayBillDate}</td>
                        <td>{jsonData?.header?.gstin}</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <ReactToPrint
                trigger={() => <button>Print this out!</button>}
                content={() => componentRef}
              />
            </>
          </Box>
        </Modal>
      )}
      <ChalanRasid chalan={details} />
    </div>
  );
}
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>;
export default ChalanForm;
function isEmptyObject(obj) {
  if (obj === undefined || obj === null) {
    return false;
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
